import AjaxSwitch from './AjaxSwitch';
customElements.define('ajax-switch', AjaxSwitch, {extends: 'input'});

import SearchBar from './SearchBar';
customElements.define('search-bar', SearchBar, { extends: 'div' });

import Search from './Search';
customElements.define('search-form', Search,{extends: 'form'});

//Pour surcharge de l'ajout au panier (caissage)
import AddToCart from "./addToCart";
customElements.define('add-to-cart-caissage', AddToCart,{extends: 'button'});

import CartDeletor from "./CartDelete";
customElements.define('cart-delete', CartDeletor, {extends: 'a'});

/**
 * Surcharge des intégrations
 */
import QuantitySelector from "./QuantitySelector";
customElements.define('quantity-selector', QuantitySelector);

import SiteHeader from "./SiteHeader";
customElements.define('site-header', SiteHeader);
